import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ModalCard, useCreateModal } from 'partial/components/Modal';

import Button from 'partial/components/Button';
import { useBanExempt } from '../hooks';

export const useOpenBanExempt = () => {
  const createModal = useCreateModal();

  const openBanExemptModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <BanExempt data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openBanExemptModal;
};

function BanExempt({ onClose, data }) {
  const [isLoading, exempt] = useBanExempt(onClose);
  const submit = () => {
    exempt(data?.uuid);
  };
  return (
    <ModalCard size="sm" title="CONFIRMATION" onClose={onClose}>
      <div className="p-5 w-full">
        <p className="text-sm font-semibold mb-6">
          Are you sure you want to proceed with this action on this account
          <span className="text-brand-600"> {data?.organization?.name}</span>?
        </p>
        <div className="flex gap-2 justify-end mt-10">
          <Button className="uppercase" onClick={onClose}>
            cancel
          </Button>
          <Button
            disabled={isLoading}
            outline
            className="uppercase"
            onClick={submit}
          >
            toggle exempt
          </Button>
        </div>
      </div>
    </ModalCard>
  );
}

BanExempt.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BanExempt;
